const scale = 2;
const tileSize = 16;
export const CONFIG = {
  debug: false,
  skipIntro: false,
  scale: scale,
  tile: {
    size: tileSize,
  },
  screen: {
    width: tileSize * 24, // 384
    height: tileSize * 12, // 192
  },
  physics: {
    gravity: 600,
  },
  santa: {
    speed: 150,
    jumpPower: 250,
  },
  elfCount: 30,
  firstLevel: 1,
  lastLevel: 4,
  levels: {
    level1: {
      timer: 15,
      santa: {
        x: 120,
        y: 275,
      },
      room: {
        left: 122,
        top: 54,
      },
    },
    level2: {
      timer: 30,
      santa: {
        x: 30,
        y: 330,
      },
      room: {
        left: 840,
        top: 176,
      },
    },
    level3: {
      timer: 50,
      santa: {
        x: 190,
        y: 330,
      },
      room: {
        left: 1300,
        top: 238,
      },
    },
    level4: {
      timer: 30,
      santa: {
        x: 30,
        y: 360,
      },
      room: {
        left: 570,
        top: 112,
      },
    },
  },
} as const;

export type LevelKey = keyof typeof CONFIG.levels;
